import React, { Component } from 'react';
import LayoutContainer from './LayoutContainer';
import Diagram from '../diagrams/Diagram';

export default class DiagramsContainer extends LayoutContainer {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {

    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.diagrams !== this.props.diagrams || nextProps.flag !== this.props.flag;
    }

    renderDiagrams() {

        let parent = this.props.parent;
        if (parent === this.props.designer.paper)
            parent = undefined;

        return this.props.diagrams.map(c => {
            c._sys.parent = parent;
            c._sys.designer = this.props.designer;
            return <Diagram key={c.id} model={c} designer={this.props.designer} />;
        });
    }

    render() {

        return (
            <div className={"diagrams-container " + (this.props.className || "")} style={this.props.parent && this.props.parent.toContainerStyle && this.props.parent.toContainerStyle()} >
                {this.renderDiagrams()}
            </div>
        );
    }
}
